export class DateRangePickers {

    pickers = {};

    /**
     * Keep track of date pickers used for each product.
     * @param product_id
     * @param element
     */
    add(product_id: number, element: HTMLElement) {
        if (this.pickers[product_id] === undefined) {
            this.pickers[product_id] = [];
        }

        this.pickers[product_id].push(element);
    }

    all(product_id) {
        return this.pickers[product_id] ?? [];
    }

    calculateDays(product_id: number) {
        let total = 0;

        function forceUTC(date): Date|null {
            return date ? new Date(Date.UTC(
                date.getFullYear(),
                date.getMonth(),
                date.getDate()
            )) : null;
        }

        jQuery(this.all(product_id)).each(function () {
            const $el = jQuery(this);
            const value = forceUTC($el.datepicker('getDate'));
            if (value === null) {
                return;
            }

            const minDate = forceUTC($el.datepicker('option', 'minDate'));
            const maxDate = forceUTC($el.datepicker('option', 'maxDate'));

            const fromDate = minDate ? minDate : value;
            const toDate = maxDate ? maxDate : value;

            if (!fromDate && !toDate) {
                return;
            }

            let days = Math.ceil((toDate.getTime() - fromDate.getTime()) / (1000 * 60 * 60 * 24));

            // We need to include the first day.
            days++;

            total += days;
        });

        return total;
    }
}
